import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { Control, FieldValues } from 'react-hook-form';
import CustomSwitch from '../Switch/Switch';
import Input from '../Input/Input';
import EDIT_ICON from '../../assets/svg/edit-icon.svg';
import DELETE_ICON from '../../assets/svg/delete-icon.svg';
import MOVEABLE from '../../assets/svg/moveable.svg';
import { LANG_TEXT } from '../../constants/language';
import { IUserMenuCategory } from '../../pages/CategoriesManagement/categoriesManagement.types';
import { ICategoryDetails } from '../../pages/MenuManagement/menu.types';

interface CategoryRowProps<TFieldValues extends FieldValues = FieldValues> {
  category: ICategoryDetails | IUserMenuCategory;
  isEdit: boolean;
  isChecked: boolean;
  control: Control<TFieldValues>;
  classes: {
    Items: string;
    EditButton: string;
    Category: string;
    Icons: string;
    EditButtonActive: string;
    DeleteButtonActive: string;
    CategoryName: string;
  };
  onSwitchChange: (categoryId: string, isChecked: boolean) => void;
  onEditClick: (category: ICategoryDetails | IUserMenuCategory, status: boolean) => void;
  onCheckIconClick: (categoryId: string) => void;
  onDeleteClick: (categoryId: string) => void;
}

function CategoryRow<TFieldValues extends FieldValues = FieldValues>({
  category,
  isEdit,
  isChecked,
  control,
  classes,
  onSwitchChange,
  onEditClick,
  onCheckIconClick,
  onDeleteClick,
}: CategoryRowProps<TFieldValues>) {
  const { t } = useTranslation();

  return (
    <Box className={classes.Items}>
      <Box className={classes.EditButton}>
        <img src={MOVEABLE} alt="MOVEABLE" />
      </Box>
      {isEdit ? (
        <Box className={classes.Category}>
          <Input
            defaultValue={category.title}
            control={control}
            name={`category_${category.id}`}
            placeholder={t(LANG_TEXT.NEW_CATEGORY)}
            type="text"
          />
          <Box className={classes.Icons}>
            <Box className={classes.EditButtonActive} onClick={() => onCheckIconClick(category.id)}>
              <CheckIcon height={20} width={20} sx={{ color: 'rgba(41, 108, 50, 1)' }} />
            </Box>
            <Box className={classes.DeleteButtonActive} onClick={() => onEditClick(category, false)}>
              <CloseIcon height={20} width={20} sx={{ color: 'rgba(180, 35, 24, 1)' }} />
            </Box>
          </Box>
        </Box>
      ) : (
        <Box className={classes.Category}>
          <CustomSwitch onChange={(checked) => onSwitchChange(category.id, checked)} isChecked={isChecked} />
          <Box className={classes.CategoryName}>
            <Typography fontSize={16} lineHeight={'24px'} color={'var(--Gray-900, #101828)'}>
              {category.title}
            </Typography>
          </Box>
          <Box className={classes.Icons}>
            <Box className={classes.EditButton} onClick={() => onEditClick(category, true)}>
              <img src={EDIT_ICON} height={24} width={24} alt="EDIT_ICON" />
            </Box>
            <Box className={classes.EditButton}>
              <img
                src={DELETE_ICON}
                height={24}
                width={24}
                alt="DELETE_ICON"
                onClick={() => onDeleteClick(category.id)}
              />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default CategoryRow;
